const glossarySearch = {
    ui: {},

    init: function() {
        this.bindUI();
        this.bindEvents();
    },

    bindUI: function bindUI() {
        this.ui.$glossaryFormSearch = $(".js-search-glossary");
        this.ui.$glossaryInputSearch = $(".js-search-glossary-input");
        this.ui.$glossarySearchTarget = $(".js-search-glossary-target");
        this.ui.$glossaryTabsContent = $(".js-tabs__content");
        this.ui.$glossaryTabsLink = $(".js-tabList__link");

        this.ui.$glossaryResults = $(".js-search-glossary-result");

    },

    bindEvents: function bindEvents() {
        this.ui.$glossaryFormSearch.on('submit', this.searchResult.bind(this));
        this.ui.$glossaryInputSearch.on('keyup', this.searchResult.bind(this));
        this.ui.$glossaryTabsLink.on('click', this.clearSearchResult.bind(this));
        //sur id js-search quand on appuie sur une touche
    },

    clearSearchResult: function(e){
        this.ui.$glossaryResults.addClass("js-hide");
        this.ui.$glossaryTabsContent.removeClass("js-hide");
    },
    searchResult: function(e){
        const val = this.ui.$glossaryInputSearch.val();
        if(val == ''){
            this.ui.clearSearchResult();
            return;
        }else{
            this.ui.$glossaryResults.removeClass("js-hide");
            this.ui.$glossaryTabsContent.addClass("js-hide");

            this.ui.$glossaryResults.html('');
            for (var i = 0; i < this.ui.$glossarySearchTarget.length; i++) {
                // si target contien val cherchée, on le met dans $glossaryResults
                if(this.ui.$glossarySearchTarget.eq(i).text().replace(/[\r\n]/gm, '').trim().toLowerCase().indexOf(val.toLowerCase()) != -1){
                    this.ui.$glossarySearchTarget.eq(i).closest(".js-search-glossary-item").clone().addClass("lexiqueColumn").appendTo(this.ui.$glossaryResults);
                }
            }
            if(this.ui.$glossaryResults.find(".js-search-glossary-item").length == 0){
                this.ui.$glossaryResults.append($('<p class="resultList__noResults">'+this.ui.$glossaryResults.attr("data-no-results")+ ' "' + val +'"</p>'));
            }
        }

    }

};

module.exports = glossarySearch;
